import { useEffect, useState } from 'react'
import api from '../../api/api'
import { endpoints } from '../../api/apiCommons'
import { surveyHero } from '../surveys'

const noop = () => {}
const sessionKey = (id) => `survey-answered-session:${id}`
const unpack = data => data && data.data ? data.data : data

export function useCompanySurvey({ companyId }) {
  const [selected, setSelected] = useState(null)
  const [loading, setLoading] = useState(true)
  const [answered, setAnswered] = useState(false)
  useEffect(() => {
    let cancel = false
    setSelected(null)
    setLoading(true)
    setAnswered(false)
    if (!companyId) { setLoading(false); return undefined }
    try {
      if (sessionStorage.getItem(sessionKey(companyId)) === '1') {
        setAnswered(true); setLoading(false); return undefined
      }
    } catch (_) {}
    api.get(endpoints.surveySeleccionar || 'Survey/Seleccionar', {
      params: { sEmpresa: companyId, _ts: Date.now() },
      headers: { token: localStorage.getItem('token') || '', 'Cache-Control': 'no-cache' },
    }).then(({data}) => {
      if (cancel) return
      const dto = unpack(data)
      setSelected(dto?.CodigoSurvey || null)
    }).catch(() => { if (!cancel) setSelected(null) })
      .finally(() => { if (!cancel) setLoading(false) })
    return () => { cancel = true }
  }, [companyId])
  const markCompleted = () => {
    try { sessionStorage.setItem(sessionKey(companyId), '1') } catch (_) {}
    setAnswered(true)
    setSelected(null)
  }
  const code = !loading && !answered ? selected : null
  return { shouldShow: Boolean(code), surveyCode: code,
    markCompleted: code ? markCompleted : noop,
    hero: code ? surveyHero[code] : undefined }
}
